// export this package's api
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _Cascader = require('./Cascader');

var _Cascader2 = _interopRequireDefault(_Cascader);

exports['default'] = _Cascader2['default'];
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-cascader/lib/index.js
 ** module id = 319
 ** module chunks = 0
 **/